import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class TelemetryService {
    private config: Microsoft.ApplicationInsights.IConfig = {
        instrumentationKey: AppConsts.applicationInsightsInstrumentationKey
    };

    constructor() {
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        }
    }

    logPageView(
        name?: string,
        url?: string,
        properties?: any,
        measurements?: any,
        duration?: number
    ) {
        AppInsights.trackPageView(
            name,
            url,
            properties,
            measurements,
            duration
        );
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        AppInsights.trackEvent(name, properties, measurements);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/telemetry/telemetryService.ts